<template>
  <svg
    id="Ebene_1"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 185 50"
    style="enable-background: new 0 0 185 50"
    xml:space="preserve">
    <g>
      <g>
        <path
          class="st0"
          d="M10.9,21.4h-1V8.7h1V21.4z" />
        <path
          class="st0"
          d="M22.2,21.4h-1l-6-10.8v10.8h-1V8.7h1l6,10.8V8.7h1V21.4z" />
        <path
          class="st0"
          d="M32.4,9.6h-3.6v11.8h-1V9.6h-3.6V8.7h8.2V9.6z" />
        <path
          class="st0"
          d="M40.6,15.3h-4.9v5.2h5.6v0.9h-6.6V8.7h6.6v0.9h-5.6v4.8h4.9V15.3z" />
        <path
          class="st0"
          d="M47.7,16.1h-2.9v5.3h-1V8.7h3.5c1.2,0,2,0.3,2.7,1c0.6,0.7,0.9,1.6,0.9,2.8c0,0.8-0.2,1.5-0.6,2.2
      c-0.4,0.6-0.9,1-1.6,1.3l2.6,5.4v0.1h-1.1L47.7,16.1z M44.7,15.2h2.6c0.7,0,1.3-0.3,1.8-0.8c0.4-0.5,0.7-1.2,0.7-2
      c0-0.9-0.2-1.6-0.7-2.1c-0.5-0.5-1.1-0.7-1.9-0.7h-2.5V15.2z" />
        <path
          class="st0"
          d="M61.7,21.4h-1l-6-10.8v10.8h-1V8.7h1l6,10.8V8.7h1V21.4z" />
        <path
          class="st0"
          d="M70.8,17.8h-4.7L65,21.4h-1l4-12.7h0.9l4,12.7h-1L70.8,17.8z M66.4,16.9h4.2l-2.1-6.8L66.4,16.9z" />
        <path
          class="st0"
          d="M81.1,9.6h-3.6v11.8h-1V9.6H73V8.7h8.2V9.6z" />
        <path
          class="st0"
          d="M84.6,21.4h-1V8.7h1V21.4z" />
        <path
          class="st0"
          d="M95.8,16.4c0,1.6-0.4,2.9-1.1,3.8c-0.7,0.9-1.7,1.3-3,1.3c-1.3,0-2.3-0.4-3-1.3c-0.7-0.9-1.1-2.2-1.1-3.8
      v-2.8c0-1.6,0.4-2.9,1.1-3.8c0.7-0.9,1.7-1.4,3-1.4c1.3,0,2.3,0.5,3,1.4c0.7,0.9,1.1,2.2,1.1,3.8V16.4z M94.8,13.6
      c0-1.4-0.3-2.4-0.8-3.1c-0.5-0.7-1.3-1-2.3-1c-1,0-1.7,0.3-2.3,1c-0.5,0.7-0.8,1.7-0.8,3.1v2.8c0,1.4,0.3,2.4,0.8,3.1
      c0.5,0.7,1.3,1.1,2.3,1.1c1,0,1.8-0.3,2.3-1c0.5-0.7,0.8-1.7,0.8-3.1V13.6z" />
        <path
          class="st0"
          d="M106.6,21.4h-1l-6-10.8v10.8h-1V8.7h1l6,10.8V8.7h1V21.4z" />
        <path
          class="st0"
          d="M115.7,17.8H111l-1.1,3.5h-1l4-12.7h0.9l4,12.7h-1L115.7,17.8z M111.3,16.9h4.2l-2.1-6.8L111.3,16.9z" />
        <path
          class="st0"
          d="M121,20.4h5.2v0.9H120V8.7h1V20.4z" />
      </g>
      <g>
        <path
          class="st0"
          d="M15.8,37.2c0-0.7-0.2-1.2-0.5-1.5c-0.3-0.3-1-0.7-1.9-1.1c-1.6-0.6-2.8-1.4-3.5-2.2c-0.7-0.8-1.1-1.8-1.1-3
      c0-1.4,0.5-2.5,1.5-3.3c1-0.8,2.2-1.3,3.7-1.3c1,0,1.9,0.2,2.7,0.6c0.8,0.4,1.4,1,1.8,1.8c0.4,0.8,0.6,1.7,0.6,2.7h-3.3
      c0-0.8-0.2-1.4-0.5-1.8c-0.3-0.4-0.8-0.6-1.4-0.6c-0.6,0-1,0.2-1.4,0.5c-0.3,0.3-0.5,0.8-0.5,1.4c0,0.5,0.2,0.9,0.5,1.2
      c0.4,0.4,1,0.7,1.9,1.1c1.6,0.6,2.8,1.3,3.5,2.1c0.7,0.8,1.1,1.9,1.1,3.2c0,1.4-0.5,2.6-1.4,3.4c-0.9,0.8-2.1,1.2-3.7,1.2
      c-1.1,0-2-0.2-2.9-0.7c-0.9-0.4-1.6-1.1-2-1.9c-0.5-0.8-0.7-1.8-0.7-2.9h3.3c0,1,0.2,1.6,0.6,2.1c0.4,0.4,1,0.6,1.8,0.6
      C15.2,39.1,15.8,38.4,15.8,37.2z" />
        <path
          class="st0"
          d="M33,41.5h-3.3v-7.1h-4.9v7.1h-3.3V25h3.3v6.7h4.9V25H33V41.5z" />
        <path
          class="st0"
          d="M47.5,34.8c0,2.2-0.5,3.9-1.6,5.2c-1,1.2-2.5,1.8-4.3,1.8c-1.8,0-3.3-0.6-4.3-1.8c-1.1-1.2-1.6-2.9-1.6-5.1
      V32c0-2.3,0.5-4,1.6-5.3c1-1.3,2.5-1.9,4.4-1.9c1.8,0,3.3,0.6,4.3,1.9c1.1,1.3,1.6,3,1.6,5.3V34.8z M44.2,32
      c0-1.5-0.2-2.6-0.6-3.3c-0.4-0.7-1.1-1.1-2-1.1c-0.9,0-1.5,0.3-1.9,1c-0.4,0.7-0.6,1.8-0.7,3.2v2.9c0,1.4,0.2,2.5,0.6,3.2
      c0.4,0.7,1.1,1,2,1c0.9,0,1.5-0.3,1.9-1c0.4-0.7,0.6-1.7,0.6-3.1V32z" />
        <path
          class="st0"
          d="M60.8,35.4L62.3,25h3.3l-2.9,16.5h-3.3l-1.9-9.7l-1.9,9.7h-3.3L49.3,25h3.3l1.5,10.4L56,25h2.8L60.8,35.4z" />
        <path
          class="st0"
          d="M78.4,27.8h-4.1v13.7H71V27.8h-4V25h11.4V27.8z" />
        <path
          class="st0"
          d="M84,41.5h-3.3V25H84V41.5z" />
        <path
          class="st0"
          d="M91.3,25L94.4,37L97.5,25h4.3v16.5h-3.3v-4.5l0.3-6.9l-3.3,11.3h-2.3L90,30.2l0.3,6.9v4.5H87V25H91.3z" />
        <path
          class="st0"
          d="M113.2,34.4h-5.2v4.4h6.1v2.8h-9.4V25h9.4v2.8h-6.1v3.9h5.2V34.4z" />
        <path
          class="st0"
          d="M123.2,37.2c0-0.7-0.2-1.2-0.5-1.5c-0.3-0.3-1-0.7-1.9-1.1c-1.6-0.6-2.8-1.4-3.5-2.2c-0.7-0.8-1.1-1.8-1.1-3
      c0-1.4,0.5-2.5,1.5-3.3c1-0.8,2.2-1.3,3.7-1.3c1,0,1.9,0.2,2.7,0.6c0.8,0.4,1.4,1,1.8,1.8c0.4,0.8,0.6,1.7,0.6,2.7h-3.3
      c0-0.8-0.2-1.4-0.5-1.8c-0.3-0.4-0.8-0.6-1.4-0.6c-0.6,0-1,0.2-1.4,0.5c-0.3,0.3-0.5,0.8-0.5,1.4c0,0.5,0.2,0.9,0.5,1.2
      c0.4,0.4,1,0.7,1.9,1.1c1.6,0.6,2.8,1.3,3.5,2.1c0.7,0.8,1.1,1.9,1.1,3.2c0,1.4-0.5,2.6-1.4,3.4c-0.9,0.8-2.1,1.2-3.7,1.2
      c-1.1,0-2-0.2-2.9-0.7c-0.9-0.4-1.6-1.1-2-1.9c-0.5-0.8-0.7-1.8-0.7-2.9h3.3c0,1,0.2,1.6,0.6,2.1c0.4,0.4,1,0.6,1.8,0.6
      C122.6,39.1,123.2,38.4,123.2,37.2z" />
      </g>
      <g>
        <path
          class="st0"
          d="M181.8,0H3.2C1.5,0,0,1.5,0,3.3v43.5C0,48.5,1.5,50,3.2,50h178.5c1.8,0,3.2-1.5,3.2-3.3V3.3
      C185,1.5,183.5,0,181.8,0z M138.8,44.6h2.1c0.2,0,0.4,0.2,0.4,0.4v2.5c0,0.2-0.2,0.4-0.4,0.4h-2.1c-0.2,0-0.4-0.2-0.4-0.4V45
      C138.5,44.8,138.6,44.6,138.8,44.6z M138.5,5V2.5c0-0.2,0.2-0.4,0.4-0.4h2.1c0.2,0,0.4,0.2,0.4,0.4V5c0,0.2-0.2,0.4-0.4,0.4h-2.1
      C138.6,5.4,138.5,5.2,138.5,5z M148.2,12h2.6c2.7,0,4.1,1.5,4.1,4.4v21.2h-3.4v-9.4h-3.9v9.4h-3.4V16.4
      C144.1,13.4,145.5,12,148.2,12z M144.2,5V2.5c0-0.2,0.2-0.4,0.4-0.4h2.1c0.2,0,0.4,0.2,0.4,0.4V5c0,0.2-0.2,0.4-0.4,0.4h-2.1
      C144.3,5.4,144.2,5.2,144.2,5z M149.8,5V2.5c0-0.2,0.2-0.4,0.4-0.4h2.1c0.2,0,0.4,0.2,0.4,0.4V5c0,0.2-0.2,0.4-0.4,0.4h-2.1
      C150,5.4,149.8,5.2,149.8,5z M152.7,45v2.5c0,0.2-0.2,0.4-0.4,0.4h-2.1c-0.2,0-0.4-0.2-0.4-0.4V45c0-0.2,0.2-0.4,0.4-0.4h2.1
      C152.5,44.6,152.7,44.8,152.7,45z M147,45v2.5c0,0.2-0.2,0.4-0.4,0.4h-2.1c-0.2,0-0.4-0.2-0.4-0.4V45c0-0.2,0.2-0.4,0.4-0.4h2.1
      C146.8,44.6,147,44.8,147,45z M164.4,12c2.7,0,4.1,1.5,4.1,4.4V24c0,2.9-1.4,4.4-4.1,4.4h-2.8v9.3h-3.4V12H164.4z M161.2,5V2.5
      c0-0.2,0.2-0.4,0.4-0.4h2.1c0.2,0,0.4,0.2,0.4,0.4V5c0,0.2-0.2,0.4-0.4,0.4h-2.1C161.4,5.4,161.2,5.2,161.2,5z M169.4,5.4h-2.1
      c-0.2,0-0.4-0.2-0.4-0.4V2.5c0-0.2,0.2-0.4,0.4-0.4h2.1c0.2,0,0.4,0.2,0.4,0.4V5C169.7,5.2,169.6,5.4,169.4,5.4z M169.7,45v2.5
      c0,0.2-0.2,0.4-0.4,0.4h-2.1c-0.2,0-0.4-0.2-0.4-0.4V45c0-0.2,0.2-0.4,0.4-0.4h2.1C169.6,44.6,169.7,44.8,169.7,45z M164,45v2.5
      c0,0.2-0.2,0.4-0.4,0.4h-2.1c-0.2,0-0.4-0.2-0.4-0.4V45c0-0.2,0.2-0.4,0.4-0.4h2.1C163.9,44.6,164,44.8,164,45z M158.4,5
      c0,0.2-0.2,0.4-0.4,0.4h-2.1c-0.2,0-0.4-0.2-0.4-0.4V2.5c0-0.2,0.2-0.4,0.4-0.4h2.1c0.2,0,0.4,0.2,0.4,0.4V5z M155.9,44.6h2.1
      c0.2,0,0.4,0.2,0.4,0.4v2.5c0,0.2-0.2,0.4-0.4,0.4h-2.1c-0.2,0-0.4-0.2-0.4-0.4V45C155.5,44.8,155.7,44.6,155.9,44.6z M175.1,5.4
      h-2.1c-0.2,0-0.4-0.2-0.4-0.4V2.5c0-0.2,0.2-0.4,0.4-0.4h2.1c0.2,0,0.4,0.2,0.4,0.4V5C175.4,5.2,175.3,5.4,175.1,5.4z M175.4,45
      v2.5c0,0.2-0.2,0.4-0.4,0.4h-2.1c-0.2,0-0.4-0.2-0.4-0.4V45c0-0.2,0.2-0.4,0.4-0.4h2.1C175.3,44.6,175.4,44.8,175.4,45z M175,12
      v25.6h-3.4V12H175z M178.3,47.5V45c0-0.2,0.2-0.4,0.4-0.4h2.1c0.2,0,0.4,0.2,0.4,0.4v2.5c0,0.2-0.2,0.4-0.4,0.4h-2.1
      C178.4,47.9,178.3,47.7,178.3,47.5z M181.1,5c0,0.2-0.2,0.4-0.4,0.4h-2.1c-0.2,0-0.4-0.2-0.4-0.4V2.5c0-0.2,0.2-0.4,0.4-0.4h2.1
      c0.2,0,0.4,0.2,0.4,0.4V5z M3.2,49.3c-1.4,0-2.5-1.1-2.5-2.5V3.3c0-1.4,1.1-2.5,2.5-2.5h131.5v48.6H3.2z" />
        <path
          class="st0"
          d="M165.1,23.7v-7.1c0-1-0.5-1.5-1.5-1.5h-2v10.1h2.2C164.7,25.2,165.1,24.7,165.1,23.7z" />
        <path
          class="st0"
          d="M151.4,16.6c0-1-0.5-1.5-1.5-1.5H149c-1,0-1.5,0.5-1.5,1.5v8.5h3.9V16.6z" />
      </g>
    </g>
  </svg>
</template>

<style scoped>
  .st0 {
    fill: #ffffff;
  }
</style>
